// extracted by mini-css-extract-plugin
module.exports = {"vUiHueLighter":"#fafafa","vUiHue":"#ddd","wrapper":"ExpandableWrapper__wrapper___sXakW"};